import { makeAutoObservable } from 'mobx';

class JobPostingNotificationsStore {

  jobPostingUpdatedNotificationVisible = false;

  setJobPostingUpdatedNotificationVisible = (value) => {
    this.jobPostingUpdatedNotificationVisible = value;
  };

  constructor() {
    makeAutoObservable(this);
  }

  showJobPostingUpdatedNotification = () => {
    this.setJobPostingUpdatedNotificationVisible(true);

    setTimeout(() => {
      this.setJobPostingUpdatedNotificationVisible(false);
    }, 5000);
  };
}

export default new JobPostingNotificationsStore();
